export default __webpack_public_path__ + "static/backgroundNewsletter-e6e8a4e18d29e94475c457125cfce5d3.png";